// Honorific-aware first-name extraction. "Dr. Nicole Avery" greets as
// "Nicole" — naive split(' ')[0] would greet her as "Dr." forever.
const HONORIFICS = new Set([
  'dr',
  'mr',
  'mrs',
  'ms',
  'miss',
  'mx',
  'prof',
  'professor',
  'sir',
  'dame',
  'madam',
  'rev',
  'reverend',
  'fr',
  'father',
  'pastor',
  'rabbi',
  'imam',
  'capt',
  'captain',
  'col',
  'colonel',
  'maj',
  'major',
  'sgt',
  'lt',
])

export function firstNameOf(fullName?: string | null): string | null {
  if (!fullName || typeof fullName !== 'string') return null
  const parts = fullName.trim().split(/\s+/)
  const first = parts.find(
    (p) => !HONORIFICS.has(p.replace(/[.,]/g, '').toLowerCase()),
  )
  return first || parts[0] || null
}
